import { IconBriefcase, IconSchool } from "@tabler/icons-react";
import styles from "../../../../pages/TalentDashboard/Profile/profile.module.css";
import Reveal from "../../../Reveal/Reveal";
import moment from "moment";

function EducationTimeline({ items }) {
  const sortedItems = [...(items || [])]?.sort((a, b) => {
    // Ongoing education first
    if (a?.isOngoing && !b?.isOngoing) return -1;
    if (!a?.isOngoing && b?.isOngoing) return 1;

    // Compare dates
    const dateA = new Date(a?.isOngoing ? a?.startDate : a?.endDate);
    const dateB = new Date(b?.isOngoing ? b?.startDate : b?.endDate);

    return dateB - dateA; // Latest first
  });
  return (
    <div className={styles.timeline}>
      {sortedItems?.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <div
            className={styles.tlItem}
            key={item?.fieldOfStudy + item?.endDate}
          >
            <div className={styles.tlMarker}>
              <span
                className={`${styles.tlDot} ${!item?.isOngoing ? styles.tlDotPast : ""}`}
              />
              <span
                className={`${styles.tlLine} ${isLast ? styles.tlLineHidden : ""}`}
              />
            </div>
            <div
              className={`${styles.tlContent} ${isLast ? styles.tlContentLast : ""}`}
            >
              <div className={styles.tlDate}>
                {item?.isOngoing ? (
                  moment(item?.startDate).format("YYYY")
                ) : (
                  <>
                    {moment(item?.startDate).format("YYYY")} -{" "}
                    {moment(item?.endDate).format("YYYY")}
                  </>
                )}
              </div>
              <div className={styles.tlTitle}>{item?.fieldOfStudy}</div>
              <div className={styles.tlSub}>{item?.schoolName}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function WorkExperienceTimeline({ items }) {
  const sortedItems = [...(items || [])]?.sort((a, b) => {
    // Current jobs always come first
    if (a?.isCurrentJob && !b?.isCurrentJob) return -1;
    if (!a?.isCurrentJob && b?.isCurrentJob) return 1;

    // Compare dates
    const dateA = new Date(a?.isCurrentJob ? a?.startDate : a?.endDate);
    const dateB = new Date(b?.isCurrentJob ? b?.startDate : b?.endDate);

    return dateB - dateA; // Newest first
  });
  return (
    <div className={styles.timeline}>
      {sortedItems?.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <div
            className={styles.tlItem}
            key={item?.companyName + item?.startDate}
          >
            <div className={styles.tlMarker}>
              <span
                className={`${styles.tlDot} ${!item?.isCurrentJob ? styles.tlDotPast : ""}`}
              />
              <span
                className={`${styles.tlLine} ${isLast ? styles.tlLineHidden : ""}`}
              />
            </div>
            <div
              className={`${styles.tlContent} ${isLast ? styles.tlContentLast : ""}`}
            >
              <div className={styles.tlDate}>
                {item?.isCurrentJob ? (
                  moment(item?.startDate).format("YYYY")
                ) : (
                  <>
                    {moment(item?.startDate).format("YYYY")} -{" "}
                    {moment(item?.endDate).format("YYYY")}
                  </>
                )}
              </div>
              <div className={styles.tlTitle}>{item?.industry}</div>
              <div className={styles.tlSub}>{item?.companyName}</div>
              <ul>
                <li>{item?.jobDescription}</li>
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function ExperienceTab({ data, resetKey }) {
  return (
    <div className={styles.stack}>
      <Reveal index={0} resetKey={resetKey}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <IconBriefcase size={18} />
              </div>
              <div>
                <div className={styles.cardTitle}>Work Experience</div>
              </div>
            </div>
          </div>
          <div className={styles.cardBody}>
            <WorkExperienceTimeline items={data?.workHistoryExperience} />
          </div>
        </div>
      </Reveal>

      <Reveal index={1} resetKey={resetKey}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <div className={styles.cardIcon}>
                <IconSchool size={18} />
              </div>
              <div>
                <div className={styles.cardTitle}>Education</div>
              </div>
            </div>
          </div>
          <div className={styles.cardBody}>
            <EducationTimeline items={data?.educations} />
          </div>
        </div>
      </Reveal>
    </div>
  );
}
